import { useState, useRef, useEffect } from 'react'
import './ActionsMenu.css'

interface ActionsMenuProps {
  onRerun: () => void
  onDownload: () => void
  onAddToProject: () => void
  disabled?: boolean
}

export default function ActionsMenu({ onRerun, onDownload, onAddToProject, disabled }: ActionsMenuProps) {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  return (
    <div className="actions-menu" ref={menuRef}>
      <button
        className="actions-menu-toggle"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
        aria-label="More actions"
        aria-expanded={isOpen}
      >
        <span className="actions-menu-icon">⋮</span>
      </button>
      {isOpen && (
        <div className="actions-menu-dropdown">
          <button
            className="actions-menu-item"
            onClick={() => {
              setIsOpen(false)
              onRerun()
            }}
          >
            <span className="actions-menu-item-icon">↻</span>
            <span>Re-run forecast</span>
          </button>
          <button
            className="actions-menu-item"
            onClick={() => {
              setIsOpen(false)
              onDownload()
            }}
          >
            <span className="actions-menu-item-icon">⇩</span>
            <span>Download JSON</span>
          </button>
          <button
            className="actions-menu-item"
            onClick={() => {
              setIsOpen(false)
              onAddToProject()
            }}
          >
            <span className="actions-menu-item-icon">＋</span>
            <span>Add to project</span>
          </button>
        </div>
      )}
    </div>
  )
}

